/* Native links, menus and disclosures work without JavaScript. */
(() => {
  if (window.RootReview) { window.RootReview.init(); return; }
  const active = new Map();
  function mount(root) {
    if (active.has(root)) return;
    const controller = new AbortController();
    const { signal } = controller;
    root.addEventListener('click', event => {
      const link = event.target.closest('a');
      if (!link) return;
      const menu = link.closest('.rr-menu');
      if (menu) menu.open = false;
      if (link.matches('[data-rr-cta]')) root.dispatchEvent(new CustomEvent('root-review:cta', { bubbles: true, detail: { label: link.dataset.rrCta, href: link.href } }));
    }, { signal });
    root.addEventListener('keydown', event => {
      if (event.key === 'Escape') { const menu = root.querySelector('.rr-menu[open]'); if (menu) { menu.open = false; menu.querySelector('summary').focus(); } }
    }, { signal });
    active.set(root, controller);
  }
  function init() { document.querySelectorAll('[data-root-review]').forEach(mount); }
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', event => { for (const [root, controller] of active) if (event.target.contains(root)) { controller.abort(); active.delete(root); } });
  window.RootReview = { init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true }); else init();
})();
